// extracted by mini-css-extract-plugin
export var container = "TopProjectsSlide-module--container--514ec";
export var fadeInAnimation = "TopProjectsSlide-module--fadeInAnimation--36f4f";
export var img = "TopProjectsSlide-module--img--a16b5";
export var layout = "TopProjectsSlide-module--layout--f21ac";
export var link = "TopProjectsSlide-module--link--5266f";
export var picture = "TopProjectsSlide-module--picture--0af59";
export var title = "TopProjectsSlide-module--title--b0510";